import { Component, OnInit } from '@angular/core';
import { BasePageComponent } from '@carm/_utils/base-page.component';

@Component({
  selector: 'carm-disbursments-terms',
  templateUrl: './disbursments-terms.component.html',
  styleUrls: ['./disbursments-terms.component.scss']
})
export class DisbursmentsTermsComponent extends BasePageComponent implements OnInit {

  public termsAndConditions = this.translateService.instant('components.confirmTermsDialog.disbursments');

  constructor() {
    super()
  }

  ngOnInit(): void {
  }
}
